<section class="snapshot-page">

  <nav class="program-tabs" role="tablist" aria-label="Executive Overview sub pages">
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'executiveOverview'"
      (click)="selectProgramPage('executiveOverview')" role="tab" [attr.aria-selected]="activeProgramPage === 'executiveOverview'">
      Executive Overview
    </button>
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'edcOperations'"
      (click)="selectProgramPage('edcOperations')" role="tab" [attr.aria-selected]="activeProgramPage === 'edcOperations'">
      EDC Operations
    </button>
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'valueAndImpact'"
      (click)="selectProgramPage('valueAndImpact')" role="tab" [attr.aria-selected]="activeProgramPage === 'valueAndImpact'">
      Value &amp; Impact
    </button>
  </nav>

  <div *ngIf="activeProgramPage === 'executiveOverview'" role="tabpanel" class="program-tab-content">
  <section class="top-grid">
    <article class="panel events-panel">
      <h3>Current Events &amp; Health Anomalies</h3>
      <p class="panel-subtitle">Click a NAMC to drill down</p>

      <table class="simple-table events-table">
        <thead>
          <tr>
            <th>NAMC</th>
            <th class="numeric-header">Current Events<br /><span class="col-unit">(#)</span></th>
            <th class="numeric-header">Health Anomalies<br /><span class="col-unit">(#)</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of currentEventsRows">
            <td>
              <button class="namc-link" type="button">
                <i class="pi pi-angle-right" aria-hidden="true"></i>
                {{ row.namc }}
              </button>
            </td>
            <td class="numeric-cell events-cell">{{ row.currentEvents }}</td>
            <td class="numeric-cell anomalies-cell">{{ row.healthAnomalies }}</td>
          </tr>
        </tbody>
      </table>

      <button class="text-link view-all-link" type="button">
        View all events
        <i class="pi pi-angle-right" aria-hidden="true"></i>
      </button>
    </article>

    <article class="panel trends-panel">
      <h3>30-Day KPI Trends by NAMC</h3>

      <div class="metric-tabs" role="tablist">
        <button type="button" class="metric-tab" *ngFor="let metric of kpiMetrics"
          [class.active]="metric === activeMetric" (click)="selectMetric(metric)">
          {{ metric }}
        </button>
      </div>

      <div class="chart-wrap">
        <div class="y-axis">
          <span *ngFor="let tick of activeChart.ticks">{{ activeChart.format(tick) }}</span>
        </div>
        <div class="chart-area">
          <svg viewBox="0 0 100 100" preserveAspectRatio="none">
            <line *ngFor="let tick of activeChart.ticks" class="grid-line"
              x1="0" [attr.y1]="getTickY(tick)" x2="100" [attr.y2]="getTickY(tick)"></line>
            <polyline *ngFor="let series of activeChart.series" class="trend-line"
              [attr.points]="getLinePoints(series.values)" [attr.stroke]="series.color"></polyline>
          </svg>
        </div>
      </div>
      <div class="x-axis">
        <span *ngFor="let label of xAxisLabels">{{ label }}</span>
      </div>

      <div class="chart-legend">
        <span class="legend-item" *ngFor="let series of activeChart.series">
          <i class="legend-dot" [style.background]="series.color"></i>
          {{ series.name }}
        </span>
      </div>
    </article>
  </section>

  <article class="panel scorecard-panel">
    <div class="scorecard-header">
      <h3>NAMC Scorecard</h3>
      <p class="panel-subtitle">Click a NAMC to drill down to Plants and Shops</p>
    </div>

    <table class="simple-table scorecard-table">
      <thead>
        <tr class="group-header-row">
          <th class="group-spacer" colspan="2"></th>
          <th class="group-header" colspan="5">Operational KPIs</th>
          <th class="group-header" colspan="5">EDC Program Score</th>
        </tr>
        <tr>
          <th>NAMC</th>
          <th>Status</th>
          <th class="numeric-header">OA<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">MTTR<br /><span class="col-unit">(hrs)</span></th>
          <th class="numeric-header">MTBF<br /><span class="col-unit">(hrs)</span></th>
          <th class="numeric-header">Uptime<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">Downtime<br /><span class="col-unit">(hrs)</span></th>
          <th class="numeric-header">Deployment<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">Health<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">Utilization<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">Adoption<br /><span class="col-unit">(%)</span></th>
          <th class="numeric-header">Overall Score</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of scorecardRows">
          <td>
            <button class="namc-link" type="button">
              <i class="pi pi-angle-right" aria-hidden="true"></i>
              {{ row.namc }}
            </button>
          </td>
          <td><span class="status-dot" [ngClass]="'status-' + row.status"></span></td>
          <td class="numeric-cell">{{ row.oa }}</td>
          <td class="numeric-cell">{{ row.mttr }}</td>
          <td class="numeric-cell">{{ row.mtbf }}</td>
          <td class="numeric-cell">{{ row.uptime }}</td>
          <td class="numeric-cell">{{ row.downtime }}</td>
          <td class="numeric-cell" [ngClass]="'value-' + scoreLevel(row.deployment ?? 0)">{{ formatOrDash(row.deployment) }}</td>
          <td class="numeric-cell" [ngClass]="row.health !== null ? 'value-' + scoreLevel(row.health) : ''">{{ formatOrDash(row.health) }}</td>
          <td class="numeric-cell" [ngClass]="row.utilization !== null ? 'value-' + scoreLevel(row.utilization) : ''">{{ formatOrDash(row.utilization) }}</td>
          <td class="numeric-cell" [ngClass]="row.adoption !== null ? 'value-' + scoreLevel(row.adoption) : ''">{{ formatOrDash(row.adoption) }}</td>
          <td class="numeric-cell">
            <span class="score-pill" [ngClass]="'score-' + scoreLevel(row.overallScore)">{{ row.overallScore }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </article>

  <article class="panel alerts-panel">
    <h3>Recent Alerts (All NAMCs)</h3>

    <table class="simple-table alerts-table">
      <thead>
        <tr>
          <th>Time</th>
          <th>NAMC</th>
          <th>Shop</th>
          <th>Alert</th>
          <th class="status-header">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let alert of recentAlerts">
          <td>{{ alert.time }}</td>
          <td>{{ alert.namc }}</td>
          <td>{{ alert.asset }}</td>
          <td>{{ alert.alert }}</td>
          <td class="status-cell">{{ alert.status }}</td>
        </tr>
      </tbody>
    </table>

    <button class="text-link view-all-link" type="button">
      View all alerts
      <i class="pi pi-angle-right" aria-hidden="true"></i>
    </button>
  </article>

  </div><!-- end executiveOverview tabpanel -->

  <div *ngIf="activeProgramPage === 'edcOperations'" role="tabpanel" class="program-tab-content">
    <app-reporting-operations></app-reporting-operations>
  </div>

  <div *ngIf="activeProgramPage === 'valueAndImpact'" role="tabpanel" class="program-tab-content">
    <app-reporting-value></app-reporting-value>
  </div>

</section>
